var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.filter)?_c('div',[_c('px-filter-navegacao',{attrs:{"title":_vm.filter.title,"options":_vm.options,"loading":_vm.loading}}),_c('v-divider',{staticClass:"mt-3 mb-3 bigger-divider"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }